import cn from "classnames";
import React, { useEffect, useState } from "react";
import type { SupportHeaderAgent } from "./supportChatHeaderAgents";
import { getSupportInitials } from "./supportChatHeaderAgents";

interface Props {
  agent: SupportHeaderAgent;
}

export default function SupportChatHeaderFace({ agent }: Props) {
  const [imageFailed, setImageFailed] = useState(false);
  const avatarUrl = agent.avatarUrl?.trim() || "";
  const showImage = Boolean(avatarUrl && !imageFailed);

  useEffect(() => {
    setImageFailed(false);
  }, [avatarUrl]);

  return (
    <span
      className={cn("wsc-face", "wsc-face--photo", {
        "wsc-face--featured": agent.featured,
      })}
      title={agent.name}
      aria-hidden
    >
      {showImage ? (
        <img
          src={avatarUrl}
          alt=""
          loading="lazy"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span className="wsc-face__initials">{getSupportInitials(agent.name)}</span>
      )}
    </span>
  );
}
